import unhead_KgADcZ0jPj from "/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_MwZUzHrRNP from "/app/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_U4BUIcs89R from "/app/node_modules/nuxt-graphql-client/dist/runtime/plugin.js";
import nuxt_plugin_6wEQMY3tee from "/app/node_modules/nuxt-delay-hydration/dist/runtime/nuxt-plugin.js";
import pwa_icons_Y6agwlnXZq from "/app/node_modules/@vite-pwa/nuxt/dist/runtime/plugins/pwa-icons.mjs";
import pwa_client_Eorgdr12jA from "/app/node_modules/@vite-pwa/nuxt/dist/runtime/plugins/pwa.client.mjs";
import __wIU51YfGxb from "/app/plugins/_.ts";
import analytics_client_mtqVw3YRXk from "/app/plugins/analytics.client.ts";
import error_handler_global_jiCc4mSkfL from "/app/plugins/error-handler.global.ts";
import global_components_9ZSxnQhvOA from "/app/plugins/global.components.ts";
import metrics_client_IWNdf5d3zu from "/app/plugins/metrics.client.ts";
import modal_UEFnUXzgTX from "/app/plugins/modal.ts";
import toast_ysMjUcU7eJ from "/app/plugins/toast.ts";
export default [
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_MwZUzHrRNP,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_U4BUIcs89R,
  nuxt_plugin_6wEQMY3tee,
  pwa_icons_Y6agwlnXZq,
  pwa_client_Eorgdr12jA,
  __wIU51YfGxb,
  analytics_client_mtqVw3YRXk,
  error_handler_global_jiCc4mSkfL,
  global_components_9ZSxnQhvOA,
  metrics_client_IWNdf5d3zu,
  modal_UEFnUXzgTX,
  toast_ysMjUcU7eJ
]